var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 155.846,
    viewBox: "0 0 95 155.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-1",
    width: 95,
    height: 155.846
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-1",
    d: "M51.132,28.493h3.884c5.736,0,9.261-4.9,9.261-10.874V10.983C64.277,4.95,60.511.35,55.017.35H43.066V43.967h8.066Zm0-20.374H53.7c2.091,0,2.512,1.971,2.512,4.6v2.271c0,2.989.178,5.737-2.512,5.737H51.132Z",
    transform: "translate(30.625 0.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-1",
    d: "M34.608,42.9V37.885a10.181,10.181,0,0,0-9.976-10.157A10.233,10.233,0,0,0,14.591,37.885V62.322A10.251,10.251,0,0,0,24.632,72.544a10.2,10.2,0,0,0,9.976-10.222V57.3H26.543v2.87c0,3.405-.717,4.6-1.911,4.6-1.258,0-1.973-1.194-1.973-4.6V40.094c0-3.465.715-4.6,1.973-4.6,1.194,0,1.911,1.134,1.911,4.6V42.9Z",
    transform: "translate(10.376 19.718)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-1",
    width: 18.821,
    height: 5.079,
    transform: "translate(49.255 39.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-1",
    d: "M38.721,36.45A10.326,10.326,0,0,0,49.3,26.232V10.161A10.314,10.314,0,0,0,38.721,0C33.226,0,28.086,4.124,28.086,10.161V26.232A10.377,10.377,0,0,0,38.721,36.45M36.152,12.371c0-2.989.657-4.6,2.568-4.6,1.855,0,2.512,1.614,2.512,4.6V24.082c0,2.986-.657,4.6-2.512,4.6-1.911,0-2.568-1.614-2.568-4.6Z",
    transform: "translate(19.973 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-1",
    d: "M36.539,61.919h5.8l1.436,9.745h8.066l-7.77-43.622H34.808L27.039,71.664H35.1Zm2.926-19.657L41.2,54.154H37.675Z",
    transform: "translate(19.228 19.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-1",
    d: "M95,79.283c0-5.137-1.554-8.785-3.766-10.7,2.031-1.792,3.167-4.777,3.167-9.139,0-7.351-3.467-11.713-10.4-11.713H73.785v43.62h9.083l-18.4,20.063H5.039V25.533L24.967,7.461v.056h5.975V43.965H39.01V7.518h5.974V.35H24.97L0,23.58v92.883H66.688L91.566,89.325C93.746,87.392,95,84.065,95,79.283M81.853,55.5H84c1.673,0,2.331.835,2.331,4,0,4.182-.536,5.556-2.331,5.556H81.853Zm0,17.327h2.57c2.031,0,2.51,1.494,2.51,6.513,0,2.81-.6,4.24-2.51,4.24h-2.57Z",
    transform: "translate(0 0.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-1",
    d: "M3.833,80.831,2.206,82.336v2.142H.785V73.512h1.42v7.036l4.273-3.9H8.191L4.9,79.881l3.622,4.6H6.776Z",
    transform: "translate(0.559 52.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-1",
    d: "M6.391,74.965a.882.882,0,0,1-.275-.652.911.911,0,0,1,.275-.659.942.942,0,0,1,.688-.272.955.955,0,0,1,.686.258.85.85,0,0,1,.274.643.9.9,0,0,1-.274.671.922.922,0,0,1-.686.277.959.959,0,0,1-.688-.267m-.022,1.774h1.42v7.832H6.369Z",
    transform: "translate(4.349 52.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-1",
    d: "M13.764,83.43a2.073,2.073,0,0,1-.768.407,3.106,3.106,0,0,1-.948.144,2.506,2.506,0,0,1-1.833-.638,2.425,2.425,0,0,1-.652-1.815v-4.3H8.234V76.057h1.33V74.341h1.42v1.716H13.23v1.169H10.984v4.24a1.352,1.352,0,0,0,.32.975,1.173,1.173,0,0,0,.909.341,1.7,1.7,0,0,0,1.107-.37Z",
    transform: "translate(5.855 52.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-1",
    d: "M14.109,82.78a3.759,3.759,0,0,1-1.472-1.427,4.245,4.245,0,0,1,0-4.122,3.7,3.7,0,0,1,1.472-1.422,4.384,4.384,0,0,1,2.134-.506,4.075,4.075,0,0,1,1.9.428,3.032,3.032,0,0,1,1.3,1.241l-1.081.7a2.336,2.336,0,0,0-.915-.842,2.564,2.564,0,0,0-1.211-.282,2.793,2.793,0,0,0-1.383.341,2.421,2.421,0,0,0-.962.967,2.94,2.94,0,0,0-.346,1.439,2.974,2.974,0,0,0,.346,1.46,2.419,2.419,0,0,0,.962.97,2.81,2.81,0,0,0,1.383.339,2.669,2.669,0,0,0,1.211-.281,2.419,2.419,0,0,0,.915-.844l1.081.679a3.116,3.116,0,0,1-1.3,1.251,4.057,4.057,0,0,1-1.9.436,4.335,4.335,0,0,1-2.134-.52",
    transform: "translate(8.607 53.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-1",
    d: "M24.167,77.439a3.4,3.4,0,0,1,.88,2.532v4.507H23.624V80.134a2.425,2.425,0,0,0-.544-1.716,2.078,2.078,0,0,0-1.569-.573,2.445,2.445,0,0,0-1.819.671,2.633,2.633,0,0,0-.664,1.93v4.033h-1.42V73.512h1.42v4.242a2.888,2.888,0,0,1,1.16-.869,3.962,3.962,0,0,1,1.6-.31,3.232,3.232,0,0,1,2.377.864",
    transform: "translate(12.522 52.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-1",
    d: "M31.085,79.764H24.732a2.452,2.452,0,0,0,.909,1.665,2.957,2.957,0,0,0,1.928.63,2.906,2.906,0,0,0,2.262-.948l.785.917a3.5,3.5,0,0,1-1.324.945,4.569,4.569,0,0,1-1.768.327,4.649,4.649,0,0,1-2.2-.512,3.629,3.629,0,0,1-1.484-1.424,4.1,4.1,0,0,1-.527-2.074,4.17,4.17,0,0,1,.512-2.055,3.683,3.683,0,0,1,1.4-1.427,4.006,4.006,0,0,1,2.021-.506,3.913,3.913,0,0,1,2,.506,3.609,3.609,0,0,1,1.376,1.427,4.376,4.376,0,0,1,.5,2.1,3.955,3.955,0,0,1-.033.428m-5.549-2.647a2.5,2.5,0,0,0-.8,1.626h5.026a2.508,2.508,0,0,0-.808-1.615,2.426,2.426,0,0,0-1.706-.63,2.466,2.466,0,0,0-1.708.619",
    transform: "translate(16.576 53.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-1",
    d: "M35.787,76.166a3.389,3.389,0,0,1,.878,2.532v4.507H35.246V78.861a2.418,2.418,0,0,0-.546-1.716,2.074,2.074,0,0,0-1.567-.573,2.445,2.445,0,0,0-1.819.671,2.633,2.633,0,0,0-.666,1.93v4.033H29.23V75.374h1.36v1.182a2.764,2.764,0,0,1,1.162-.933,4.035,4.035,0,0,1,1.66-.322,3.228,3.228,0,0,1,2.375.864",
    transform: "translate(20.786 53.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-1",
    d: "M36.134,83.038a4.079,4.079,0,0,1-1.393-.659l.592-1.124a4.172,4.172,0,0,0,1.259.592,5.02,5.02,0,0,0,1.494.224c1.241,0,1.862-.352,1.862-1.066a.693.693,0,0,0-.253-.565,1.585,1.585,0,0,0-.625-.3c-.255-.063-.611-.135-1.073-.214a10.053,10.053,0,0,1-1.545-.341,2.355,2.355,0,0,1-1.028-.65,1.812,1.812,0,0,1-.429-1.287,2.009,2.009,0,0,1,.888-1.708,3.94,3.94,0,0,1,2.378-.64,6.733,6.733,0,0,1,1.569.187,4.206,4.206,0,0,1,1.285.522l-.606,1.122a4.082,4.082,0,0,0-2.264-.621,2.615,2.615,0,0,0-1.372.293.9.9,0,0,0-.476.785.742.742,0,0,0,.269.6,1.6,1.6,0,0,0,.655.327c.264.067.628.145,1.1.236a12.254,12.254,0,0,1,1.531.347,2.335,2.335,0,0,1,.994.628,1.74,1.74,0,0,1,.416,1.242,1.956,1.956,0,0,1-.91,1.694,4.288,4.288,0,0,1-2.476.63,6.541,6.541,0,0,1-1.846-.26",
    transform: "translate(24.705 53.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-1",
    d: "M8.845,93.849,7.471,92.478A4.788,4.788,0,0,1,4.01,93.806a4.839,4.839,0,0,1-1.862-.339,3.04,3.04,0,0,1-1.294-.953,2.259,2.259,0,0,1-.465-1.4,2.612,2.612,0,0,1,.583-1.677,6.727,6.727,0,0,1,1.93-1.5,5.182,5.182,0,0,1-.962-1.227,2.43,2.43,0,0,1-.281-1.134,2.086,2.086,0,0,1,.76-1.689,3.05,3.05,0,0,1,2.035-.637,2.873,2.873,0,0,1,1.877.575,1.948,1.948,0,0,1,.693,1.581,2.134,2.134,0,0,1-.508,1.4,6.184,6.184,0,0,1-1.692,1.306l2.558,2.541a6.561,6.561,0,0,0,.635-1.877l1.138.368a6.775,6.775,0,0,1-.9,2.365l1.388,1.395Zm-2.218-2.2L3.686,88.72a5.288,5.288,0,0,0-1.489,1.1,1.743,1.743,0,0,0-.419,1.145,1.406,1.406,0,0,0,.642,1.2,2.853,2.853,0,0,0,1.68.459,3.455,3.455,0,0,0,2.527-.977m-3.26-7.017a1.172,1.172,0,0,0-.392.91,1.491,1.491,0,0,0,.214.767,5.879,5.879,0,0,0,.835,1.008,6.235,6.235,0,0,0,1.413-.991,1.3,1.3,0,0,0,.392-.9,1.054,1.054,0,0,0-.361-.83,1.52,1.52,0,0,0-1.015-.306,1.574,1.574,0,0,0-1.087.342",
    transform: "translate(0.277 59.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-1",
    d: "M8.543,93.378a3.258,3.258,0,0,1-1.285-1.1l.857-1A2.552,2.552,0,0,0,10.273,92.5a1.645,1.645,0,0,0,1.323-.53,2.383,2.383,0,0,0,.452-1.569V84.589H8.307V83.3h5.2v7.022a3.631,3.631,0,0,1-.82,2.584,3.182,3.182,0,0,1-2.418.862,3.865,3.865,0,0,1-1.73-.392",
    transform: "translate(5.161 59.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-1",
    d: "M14,92.2a3.74,3.74,0,0,1-1.453-1.425,4.294,4.294,0,0,1,0-4.122A3.686,3.686,0,0,1,14,85.235a4.3,4.3,0,0,1,2.1-.506,4.252,4.252,0,0,1,2.093.506,3.7,3.7,0,0,1,1.449,1.422,4.318,4.318,0,0,1,0,4.122A3.754,3.754,0,0,1,18.191,92.2a4.223,4.223,0,0,1-2.093.52A4.274,4.274,0,0,1,14,92.2m3.453-1.069a2.455,2.455,0,0,0,.939-.975,3.222,3.222,0,0,0,0-2.883,2.416,2.416,0,0,0-.939-.968,2.866,2.866,0,0,0-2.7,0,2.493,2.493,0,0,0-.948.968,3.179,3.179,0,0,0,0,2.883,2.535,2.535,0,0,0,.948.975,2.8,2.8,0,0,0,2.7,0",
    transform: "translate(8.546 60.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-1",
    d: "M17.934,84.389a.864.864,0,0,1-.274-.649.9.9,0,0,1,.274-.659.94.94,0,0,1,.69-.274.97.97,0,0,1,.686.26.851.851,0,0,1,.274.643.918.918,0,0,1-.274.672,1,1,0,0,1-1.376.005m-.022,1.774h1.42V94h-1.42Z",
    transform: "translate(12.558 58.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    className: "cls-1",
    d: "M26.662,85.592a3.39,3.39,0,0,1,.881,2.532v4.511h-1.42V88.287a2.418,2.418,0,0,0-.546-1.716A2.057,2.057,0,0,0,24.01,86a2.427,2.427,0,0,0-1.817.671,2.631,2.631,0,0,0-.667,1.928v4.038H20.1V84.8h1.36v1.186a2.75,2.75,0,0,1,1.162-.933,4.1,4.1,0,0,1,1.663-.322,3.217,3.217,0,0,1,2.372.864",
    transform: "translate(14.297 60.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-1",
    d: "M33.256,89.191H26.9a2.466,2.466,0,0,0,.912,1.665A3.218,3.218,0,0,0,32,90.537l.784.917a3.428,3.428,0,0,1-1.323.945,4.987,4.987,0,0,1-3.968-.185,3.609,3.609,0,0,1-1.485-1.427,4.086,4.086,0,0,1-.527-2.07,4.207,4.207,0,0,1,.508-2.057,3.692,3.692,0,0,1,1.407-1.425,4,4,0,0,1,2.019-.506,3.909,3.909,0,0,1,2,.506,3.627,3.627,0,0,1,1.376,1.425,4.388,4.388,0,0,1,.5,2.1,3.884,3.884,0,0,1-.031.428M27.7,86.544a2.515,2.515,0,0,0-.806,1.626h5.027a2.516,2.516,0,0,0-.8-1.617,2.652,2.652,0,0,0-3.417-.009",
    transform: "translate(18.119 60.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-1",
    d: "M33.524,85.078a3.993,3.993,0,0,1,1.757-.349V86.1a2.653,2.653,0,0,0-.322-.014,2.4,2.4,0,0,0-1.814.688,2.725,2.725,0,0,0-.657,1.961v3.9h-1.42V84.8h1.362v1.318a2.451,2.451,0,0,1,1.093-1.037",
    transform: "translate(22.094 60.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-1",
    d: "M42.249,84.769l-3.8,8.624a3.87,3.87,0,0,1-1.174,1.682,2.672,2.672,0,0,1-1.62.489,3.483,3.483,0,0,1-1.117-.183,2.3,2.3,0,0,1-.891-.542l.606-1.064a1.965,1.965,0,0,0,1.4.578,1.326,1.326,0,0,0,.864-.277,2.346,2.346,0,0,0,.631-.938l.252-.546-3.46-7.823h1.478l2.733,6.271,2.707-6.271Z",
    transform: "translate(23.926 60.281)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ee6aeb0bc9fc4a254867ec1c1f920656.svg";
export { ForwardRef as ReactComponent };